import React, { memo } from 'react';

function SvgRectInner(
  props: {
    x1: number;
    x2: number;
    y1: number;
    y2: number;
    zigHeight: number;
  } & React.SVGProps<SVGPathElement>,
) {
  const { x1, x2, y1, y2, zigHeight, ...otherProps } = props;
  return (
    <path
      d={`M ${x1} ${y1}  L ${x2} ${y1} L ${x2} ${y2}  L ${x1} ${y2} L ${x1} ${y1}`}
      {...otherProps} // eslint-disable-line react/jsx-props-no-spreading
    />
  );
}

export const SvgRect = memo(SvgRectInner);

export function SvgBarberPoleMask({ chartId }: { chartId: string }) {
  const patternId = `pattern-barberpole-${chartId}`;
  const chevronId = `chevron-${chartId}`;
  const maskId = `barberpole-mask-${chartId}`;

  return (
    <defs>
      <pattern
        id={patternId}
        x="0"
        y="0"
        patternUnits="userSpaceOnUse"
        width="20"
        height="10"
        viewBox="0 0 20 10"
        patternTransform="scale(0.5)"
      >
        <g id={chevronId} fill="white">
          <path d="M0 0 L 20 10 L 10 10 L 0 5 L 0 0" />
          <path d="M10 0 L 20 0 L 20 5 L 10 0" />
        </g>

        <use x="0" y="10" href={`#${chevronId}`} />
      </pattern>

      <mask id={maskId} x="0" y="0" width="10" height="10">
        <rect
          x="0"
          y="0"
          width="8000"
          height="2000"
          fill="white"
          opacity={0.8}
        />
        <rect
          x="0"
          y="0"
          width="8000"
          height="2000"
          fill={`url(#${patternId})`}
        />
      </mask>
    </defs>
  );
}
